var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1F4C9F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 10.8281L9 3.65625L14.625 10.8281V13.2188L9 6.04688L3.375 13.2188V10.8281ZM9.28125 11.5312C8.90829 11.5312 8.5506 11.3831 8.28688 11.1194C8.02316 10.8556 7.875 10.498 7.875 10.125C7.875 9.75204 8.02316 9.39435 8.28688 9.13063C8.5506 8.86691 8.90829 8.71875 9.28125 8.71875C9.65421 8.71875 10.0119 8.86691 10.2756 9.13063C10.5393 9.39435 10.6875 9.75204 10.6875 10.125C10.6875 10.498 10.5393 10.8556 10.2756 11.1194C10.0119 11.3831 9.65421 11.5312 9.28125 11.5312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApex);
export default __webpack_public_path__ + "static/media/apex.104344aa63d7aa2240f6dab48c6269db.svg";
export { ForwardRef as ReactComponent };